export const isValueTruthy = (value) => {
  let parsedValue = value;
  parsedValue = value && (typeof value === 'string' ? value.toLowerCase() : value);
  return (
    parsedValue === true
    || parsedValue === 'true'
    || parsedValue === 'y'
    || parsedValue === 'yes'
  );
};
